import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { CandidateGridInfo, EmployeeProfileApi, SortParameters } from 'src/app/core/api.gen';
import { isNullOrUndefined } from '../../../../app/core/utils';

@Component({
  selector: 'eos-user-request',
  templateUrl: './user-request.component.html',
  styleUrls: ['./user-request.component.css']
})
export class UserRequestComponent implements OnInit {

  data: CandidateGridInfo;
  currentPage: number;
  totalRecords: number;
  totalPages: number;
  changeCount: number[] = [10, 15, 25, 50, 75];
  pages: number[] = [];
  tableLoading = true;
  pageNumber = 1;
  @Input() gpn:string;
  @Input() gui:string;

  constructor(
    private employeeApi: EmployeeProfileApi,
    public modal: NgbActiveModal) {
    this.data = new CandidateGridInfo();
  }

  ngOnInit() {
    this.data.sortParameters = new SortParameters();
    this.data.sortParameters.page = 1;
    this.data.sortParameters.itemsPerPage = 10;
    this.getAllRequest();

  }


  gridConfigure() {
    this.currentPage = this.data.sortParameters ? this.data.sortParameters.page : 1;
    this.totalRecords = this.data.sortParameters ? this.data.sortParameters.totalRecords : 0;

    this.numberOfPages();
    this.pageGenerate();

    if (!isNullOrUndefined(this.data.immigrationProfiles)) {
      if (this.data.immigrationProfiles.length) {
        this.tableLoading = false;
      } else {
        this.tableLoading = null;
      }
    }

  }

  numberOfPages() {
    this.totalPages = this.data.sortParameters ?
      Math.ceil(this.data.sortParameters.totalRecords / this.data.sortParameters.itemsPerPage) : 0;

    return this.totalPages;
  }

  pageGenerate() {
    this.pages = [];

    for (let i = 0; i < (this.totalPages > 5 ? 5 : this.totalPages); i++) {
      this.pages.push(i);
    }

    if (this.totalPages <= 5) {
      this.pageNumber = 1;
    } else if (this.currentPage - 4 > 0) {
      this.pageNumber = this.currentPage - 4;
    }
  }

  pageChange(page: number) {

    if (page > this.totalPages || page <= 0) {
      this.pageNumber = page > this.totalPages ? this.totalPages : 1;
      return;
    }

    if ((page === this.pageNumber + 4) && !((page + 4) > this.totalPages)) {
      this.pageNumber = this.pageNumber + 4;
    } else if ((page === this.pageNumber) && (page - 4) > 0) {
      this.pageNumber = this.pageNumber - 4;
    } else if ((page === this.pageNumber + 4) && ((page + 4) > this.totalPages)) {
      this.pageNumber = this.pageNumber + (this.totalPages - page);
    } else if ((page === this.pageNumber) && (page - 4) < 1) {
      this.pageNumber = 1;
    } else if ((page < this.pageNumber) && (this.pageNumber - 4) > 0) {
      this.pageNumber = this.pageNumber - 4;
    } else if ((page > this.pageNumber + 4) && (page + 4) <= this.totalPages) {
      this.pageNumber = page;
    } else if ((page > this.pageNumber + 4) && (page + 4) > this.totalPages) {
      this.pageNumber = page - ((page + 4) - this.totalPages);
    }

    if (page === 1) {
      this.pageNumber = 1;
    }

    this.data.sortParameters.page = page;
    this.currentPage = this.data.sortParameters.page;
    this.data.sortParameters.tileRefreshNeeded = false;
    this.getAllRequest();
  }
  onSelectChanges() {
    if (this.currentPage > this.numberOfPages()) {
      this.data.sortParameters.page = this.numberOfPages();
    }
    this.data.sortParameters.tileRefreshNeeded = false;
    this.getAllRequest();
  }

  getAllRequest() {

    this.employeeApi.getAllEmployeeRequests(this.gpn,this.gui, this.data.sortParameters).pipe(finalize(() => {
    })).subscribe(resp => {
      if (resp) {
        this.data = resp;
        this.gridConfigure();
      }
    });
  }



}
